const DEFAULT_MIN_CHARS = 2;
const MIN_BY_LOCALE: { [key: string]: number } = {
  'zh-TW': 1,
  'ko-KR': 1,
};

export const getMinRequiredChars = (locale: string) => MIN_BY_LOCALE[locale] || DEFAULT_MIN_CHARS;
